/**
 * clearAllWqPersistStates
 *
 * @todo add removing other storage types in the future
 * ex, 'wqFilterState', 'wqPopulationSortingState', etc
 */
export const clearAllWqPersistStates = () => {
  const keysToRemove = Object.keys(localStorage).filter((key) =>
    key.includes('ColumnState')
  );
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
